import React, { useState, useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import Menu from '../../components/Menu/Menu'
import UserRow from './UserRow'
import Pagination from '../../utils/pagination/Pagination'
import { getActiveUsers, getUsers } from '../../services/UsersService'
import UserModal from './UserModal/UserModal'
import UserBinaryModal from './UserModal/UserBinaryModal'
import { i18n } from '../../utils/translates/i18n'
import { toast } from 'react-toastify'
import { decrypt } from '../../utils/crypto'

function Users() {
  const rule = decrypt(sessionStorage.getItem('rule'))

  const defaultLocation = useLocation()
  const history = useHistory()

  const [users, setUsers] = useState([])
  const [activeUsers, setActiveUsers] = useState([])
  const [editUser, setEditUser] = useState({})

  // PARA PAGINAÇÃO
  const token = sessionStorage.getItem('token')
  const [search, setSearch] = useState('')
  const [count, setCount] = useState(0)
  const [page, setPage] = useState(1)
  const [lim, setLims] = useState(5)

  const doGetUsers = async () => {
    const success = await getUsers(token, page, lim, search)
    if (success.status) {
      // console.log(success);
      setCount(success.list.count)
      setUsers(success.list.rows)
      const resp = await getActiveUsers(token)
      if (resp.length > 0) setActiveUsers(resp)
    } else {
      toast.error(success.error)
    }
  }

  useEffect(() => {
    doGetUsers()
  }, [token, page, lim, search])

  function getPage(location) {
    if (!location) location = defaultLocation
    return new URLSearchParams(location.search).get('page')
  }

  useEffect(() => {
    return history.listen(location => {
      setPage(getPage(location))
    })
  }, [history])
  // FIM PARA PAGINAÇÃO

  function onEditClick(event) {
    const id = event.target.id.replace('edit', '')
    setEditUser(users.find(u => u.id == id))
  }

  function onBinaryClick(event) {
    const id = event.target.id.replace('binary', '')
    setEditUser(users.find(u => u.id == id))
  }

  function onModalSubmit(event) {
    history.go(0)
  }

  return (
    <React.Fragment>
      <Menu />
      <main className="content">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
          <div className="d-block mb-4 mb-md-0">
            <h2 className="h4">{i18n.t('users')}</h2>
          </div>
        </div>
        <Pagination count={count} pageSize={lim}>
          <div className="align-items-center">
            <div className="alert bg-dark m-0 py-2 d-flex justify-content-around align-items-center">
              <i className="fas fa-search"></i>
            </div>
          </div>
          <div className="input-group mx-3">
            <input
              className="form-control"
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder={`${i18n.t('search')} ${i18n.t('by')} ${i18n.t('nick')}`}
            />
          </div>
          <select className="form-select w-50" value={lim} onChange={e => setLims(e.target.value)}>
            <option className="bg-light" value="5">
              5 {i18n.t('registers')}
            </option>
            <option className="bg-light" value="10">
              10 {i18n.t('registers')}
            </option>
            <option className="bg-light" value="25">
              25 {i18n.t('registers')}
            </option>
            <option className="bg-light" value="50">
              50 {i18n.t('registers')}
            </option>
            <option className="bg-light" value="100">
              100 {i18n.t('registers')}
            </option>
          </select>
        </Pagination>
        <div className="card card-body border-0 shadow table-wrapper table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                <th className="border-gray-200">{i18n.t('nick')}</th>
                <th className="border-gray-200">{i18n.t('name')}</th>
                <th className="border-gray-200">{i18n.t('plan')}</th>
                <th className="border-gray-200">{i18n.t('type')}</th>
                <th className="border-gray-200">{i18n.t('email')}</th>
                <th className="border-gray-200">{i18n.t('indicant')}</th>
                {/* <th className='border-gray-200'>{i18n.t('traderbot')}</th> */}
                <th className="border-gray-200">{i18n.t('action')}</th>
              </tr>
            </thead>
            <tbody>
              {users && users.length ? (
                users.map(
                  user =>
                    user.nick !== 'sistema' &&
                    user.nick !== 'mastersystem' && (
                      <UserRow
                        key={user.id}
                        data={user}
                        onEditClick={onEditClick}
                        onBinaryClick={onBinaryClick}
                        rule={rule}
                        // onStopClick={onStopClick}
                        // onDeleteClick={onDeleteClick}
                      />
                    )
                )
              ) : (
                <React.Fragment></React.Fragment>
              )}
            </tbody>
          </table>
          <Pagination count={count} />
        </div>
      </main>
      {/* <Footer /> */}
      {['developer', 'manager', 'admlotteries', 'support', 'finance'].includes(rule) && (
        <UserModal data={editUser} onSubmit={onModalSubmit} activeUsers={activeUsers} rule={rule} />
      )}
      {['developer', 'finance'].includes(rule) && (
        <UserBinaryModal userName={editUser.fullName} binaries={editUser.binary} doSubmit={onModalSubmit} />
      )}
    </React.Fragment>
  )
}

export default Users
